import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import {
  fetchAdminUserData,
  setInitialized as setAdminInitialized,
} from "./redux/slices/adminAuthSlice";
import { fetchUserData, setInitialized } from "./redux/slices/authSlice";
import { fetchCartItems } from "./redux/slices/cartSlice";
import { getCategories, getSubCategories } from "./redux/slices/categorySlice";
import { getWishlist } from "./redux/slices/wishListSlice";
import AppRouter from "./routes";
import Analytics from "./seo/Analytics";
import ScrollToTop from "./shared/Scroll";

function App() {
  const token = localStorage.getItem("token");
  const adminToken = localStorage.getItem("adminAuthToken");
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const adminUser = useSelector((state) => state.adminAuth.user);

  useEffect(() => {
    // Fetch categories and subcategories on app load
    dispatch(getCategories());
    dispatch(getSubCategories());
  }, [dispatch]);

  useEffect(() => {
    if (adminUser) {
      // Re-fetch category data when admin logs in to ensure fresh data
      dispatch(getCategories());
      dispatch(getSubCategories());
    }
  }, [adminUser, dispatch]);

  useEffect(() => {
    if (token) {
      dispatch(fetchUserData());
    } else {
      // No token, mark auth as initialized
      dispatch(setInitialized(true));
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (adminToken) {
      dispatch(fetchAdminUserData());
      dispatch(getCategories());
      dispatch(getSubCategories());
      // Lazy load these in Admin Dashboard instead
      // dispatch(fetchAdminStats());
      // dispatch(getOffers());
      // dispatch(fetchOrders());
      // dispatch(fetchProducts());
      // dispatch(fetchUsers());
    } else {
      // No admin token, mark admin auth as initialized
      dispatch(setAdminInitialized(true));
    }
  }, [dispatch, adminToken]);

  // Removed global fetchAllProducts - moved to ProductFilterPage
  // useEffect(() => {
  //   dispatch(fetchAllProducts());
  //   dispatch(fetchCategory("newarrivals"));
  // }, [dispatch]);

  useEffect(() => {
    if (user) {
      // Orders and Addresses should be fetched on Profile/Order pages
      // dispatch(getOrders());
      // dispatch(fetchAddresses());

      // Keep Cart and Wishlist for Header/Navigation
      dispatch(getWishlist());
      const fetchCartItem = async () => {
        try {
          dispatch(fetchCartItems());
        } catch (error) {
          console.error("Error fetching cart items:", error);
        }
      };

      fetchCartItem();
    }
  }, [user, dispatch]);

  return (
    <Router>
      <Analytics />
      <ScrollToTop />
      <AppRouter />
    </Router>
  );
}

export default App;
